export default __webpack_public_path__ + "static/media/Group1.a727108f.svg";